import { atom } from 'nanostores'

interface DialogData {
  title: string
  description: string
  button: string
  action?: () => void
  asyncAction?: () => Promise<void>
  closeButton?: boolean
}

interface State {
  isOpen: boolean
  isLoading: boolean
  dialog: DialogData
}

const initialState: State = {
  isOpen: false,
  isLoading: false,
  dialog: {
    title: '',
    description: '',
    button: '',
  },
}

export const $dialog = atom<State>(initialState)

export const dialog = {
  open: (payload: DialogData) => {
    $dialog.set({
      dialog: payload,
      isOpen: true,
      isLoading: false,
    })
  },
  close: () => {
    $dialog.set({
      ...$dialog.get(),
      isOpen: false,
      isLoading: false,
    })
  },
  setLoading: (isLoading: boolean) => {
    $dialog.set({
      ...$dialog.get(),
      isLoading,
    })
  },
}
